<template>
  <div>
    <b-card v-loading="optionsLoding">
      <div class="title">
        <p>
          <span>{{
            pagePath == "/dashboard/create-admin-properties-options"
              ? "創立"
              : "修訂"
          }}</span
          >屬性選項
        </p>
      </div>
      <div v-if="pagePath == '/dashboard/edit-admin-properties-options'">
        <p class="sub-title">已在案之選項</p>
        <div class="mt-1">
          <table width="100%">
            <thead>
              <tr>
                <th style="width: 150px"></th>
                <th>排列次序</th>
                <th>{{ isTheatreDay ? '名稱' : 'Selection' }}</th>
                <th>{{ isTheatreDay ? '值' : '選項名稱（中文説明）' }}</th>
                <th v-if="!isTheatreDay">默認選項</th>
              </tr>
            </thead>
            <tbody>
              <tr class="sub-title sub-bg">
                <td :colspan="isTheatreDay ? 4 : 5">
                  <div v-for="(item, index) in options" :key="index">
                    <span v-if="optionType == item.value">{{ item.text }}</span>
                  </div>
                </td>
              </tr>
              <tr v-for="(cateItem, cateIndex) in selectList" :key="cateIndex">
                <td>
                  <span v-if="pageId == cateItem.id" class="edit-select"
                    >（修訂之中的項目）</span
                  >
                </td>
                <td>{{ cateIndex + 1 }}</td>
                <td :style="pageId == cateItem.id ? nameColor : ''">
                  {{ cateItem.name_en }}
                </td>
                <td :style="pageId == cateItem.id ? nameColor : ''">
                  {{ cateItem.name_zh_hk }}
                </td>
                <td v-if="!isTheatreDay">
                  <div
                    v-if="
                      adminStaff.setDefault == false && cateItem.is_default == 1
                    "
                  >
                    <feather-icon
                      style="color: #000"
                      icon="ArrowLeftIcon"
                    ></feather-icon>
                    默認選項
                  </div>
                  <div
                    v-if="
                      adminStaff.setDefault == true && pageId == cateItem.id
                        ? true
                        : false
                    "
                  >
                    <feather-icon
                      style="color: #000"
                      icon="ArrowLeftIcon"
                    ></feather-icon>
                    默認選項
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="line"></div>
      </div>
      <div class="edit-font">
        <p class="sub-title" v-for="(item, index) in options" :key="index">
          <span v-if="optionType == item.value">{{
            pagePath == "/dashboard/create-admin-properties-options"
              ? "創立"
              : "修訂"
          }}</span
          ><span v-if="optionType == item.value">
            {{ item.text }} 選項(Admin Staff)</span
          >
        </p>
        <div class="d-flex align-items-center mt-1 pt-1 case-tank">
          <b-col sm="2">
            <label for="">{{
              isTheatreDay ? '名稱(Name) :' : 'Selection(XML Value) :'
            }}</label>
          </b-col>
          <b-col sm="8">
            <b-form-input type="text" v-model="adminStaff.selection" />
          </b-col>
        </div>
        <div class="d-flex align-items-center mt-1 pt-1 case-tank">
          <b-col sm="2">
            <label for="">{{
              isTheatreDay ? '值(Value) :' : '選項名稱(中文説明) :'
            }}</label>
          </b-col>
          <b-col sm="8">
            <datePickerCom
              v-if="isTheatreDay"
              :pickTimeVal.sync="adminStaff.name_cn"
              :inputWidth="'100%'"
            />
            <b-form-input v-else type="text" v-model="adminStaff.name_cn" />
          </b-col>
        </div>
        <!-- 輪次字典（film_version）專屬：輪次編號 run_no --------------------------
             它是系統判定「首映／第幾輪」的唯一依據，與 name_en 解耦，不展示給使用者。
             新增：可留空（後端按 name_en 派生）；編輯：只讀，避免誤以為能直接改。 -->
        <div
          v-if="isFilmVersion"
          class="d-flex align-items-center mt-1 pt-1 case-tank"
        >
          <b-col sm="2">
            <label for="">輪次編號(Run No.) :</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              v-if="isCreate"
              type="text"
              maxlength="50"
              v-model="adminStaff.runNo"
              placeholder="留空＝由後端自動派生（例：12.0 → 12）"
            />
            <b-form-input
              v-else
              type="text"
              :value="currentRunNo"
              readonly
            />
            <small v-if="runNoHint" :class="runNoHintTone" class="d-block">
              {{ runNoHint }}
            </small>
            <small v-else class="text-muted d-block">
              輪次編號供系統判定首映／第幾輪，不會顯示給使用者。
              <template v-if="!isCreate">
                建立後不可自由指定，只能在「現值」與「名稱推導值」之間二選一。
              </template>
            </small>
          </b-col>
        </div>
        <div
          v-if="!isTheatreDay"
          class="d-flex align-items-center mt-1 pt-1 case-tank"
        >
          <b-col sm="2">
            <label for="">預定為默認選項(Set"Selected") :</label>
          </b-col>
          <b-col sm="8">
            <b-form-checkbox
              id="checkbox-1"
              @change="checkChange"
              v-model="adminStaff.setDefault"
              name="checkbox-1"
            >
            </b-form-checkbox>
          </b-col>
        </div>
        <div class="d-flex align-items-center mt-1 pt-1 case-tank">
          <b-col sm="2">
            <label for="">備注(Remarkes) :</label>
          </b-col>
          <b-col sm="8">
            <b-form-textarea
              id="textarea-small"
              size="sm"
              v-model="adminStaff.remarks"
              placeholder="Remarks"
            ></b-form-textarea>
          </b-col>
        </div>
        <div class="d-flex align-items-center mt-1 pt-1 case-tank">
          <b-col sm="2"> </b-col>
          <b-col sm="8">
            <b-button
              size="sm"
              class="mr-2"
              style="width: 100%"
              :disabled="submitting"
              @click="saveInfo"
              variant="outline-primary"
            >
              {{ submitting ? '處理中…' : 'Save / 存檔' }}
            </b-button>
          </b-col>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import datePickerCom from '@/views/components/datePicker.vue'
import {
  getManageProperties,
  // 取別名：避免與選項的 method 同名造成混淆
  editManageProperties as editManagePropertiesApi,
  creatManageProperties as creatManagePropertiesApi
} from '@/api/properties'

export default {
  components: { datePickerCom },
  data() {
    return {
      optionsLoding: false,
      nameColor: {
        color: '#fa0606'
      },
      options: [
        { text: '使用者類別', value: 'user_type' },
        { text: '影片格式', value: 'film_format' },
        { text: '音軌語言', value: 'film_language' },
        { text: '月份', value: 'month' },
        { text: '開拍國家', value: 'film_country' },
        { text: '電影評級', value: 'film_rating' },
        { text: '視像效果', value: 'film_visual_effect' },
        { text: '分區', value: 'film_region' },
        { text: '字幕語言', value: 'film_title_language' },
        { text: '系統語言', value: 'manage-properties' },
        { text: '影片輪次', value: 'film_version' },
        { text: '戲院日', value: 'theatre_day_list' }
      ],
      adminStaff: {
        selection: '',
        name_cn: '',
        setDefault: '',
        remarks: '',
        // 輪次字典用：使用者手填的輪次編號（新增時可留空＝後端派生）
        runNo: ''
      },
      // 目前這一列的輪次編號（編輯時只讀展示；也是 mismatch/undeterminable 的「現值」來源）
      currentRunNo: '',
      // 後端按「目前 name_en」現算的輪次編號（null = 派生不出）。
      // 2026-09 後端新增此欄位後，前端不再自己實作派生規則（Str::slug 有字元轉寫能力，
      // 前端複製一份必然漂移），一律以它為準。
      derivedRunNo: null,
      submitting: false,
      pageId: '',
      optionType: '',
      pagePath: '',
      selectList: [],
      pageIndex: ''
    }
  },
  computed: {
    isTheatreDay() {
      return this.optionType === 'theatre_day_list'
    },
    // 只有輪次字典需要輪次編號
    isFilmVersion() {
      return this.optionType === 'film_version'
    },
    isCreate() {
      return this.pagePath === '/dashboard/create-admin-properties-options'
    },
    // 輪次編號提示：新增＝說明可以留空（派生不出時存檔會請你補）；
    // 編輯＝用後端回傳的 derived_run_no 預告「存檔時會發生什麼」。
    // 注意：這裡不自己算派生值 —— 後端用 Str::slug（有字元轉寫），前端算不準。
    //
    // ⚠️ PUT 的規則是「不能**自由指定** run_no」，只能在「現值」與「派生值」之間二選一
    //    （後端驗證：兩者皆非 → 422 invalid_run_no）。
    //    所以編輯時若派生不出（derived = null），唯一有效值就是現值 → 直接沿用，不必問使用者。
    runNoHint() {
      if (!this.isFilmVersion) {
        return ''
      }
      if (this.isCreate) {
        return '留空＝由後端按名稱自動派生；純中文或「1.5」這類派生不出時，存檔會請你補填。'
      }
      const current = this.currentRunNo
      if (!current) {
        return ''
      }
      const derived = this.derivedRunNo
      if (derived === null || derived === undefined || derived === '') {
        return `目前名稱推導不出輪次編號；存檔時會沿用現值「${current}」。`
      }
      if (derived !== current) {
        return `目前名稱推導出的輪次編號是「${derived}」，與現值「${current}」不同；存檔時會請你在兩者之間二選一。`
      }
      return ''
    },
    runNoHintTone() {
      // 新增時只是說明；編輯時是真的「存檔會被問」，用警示色
      return this.isCreate ? 'text-muted' : 'text-danger'
    }
  },
  methods: {
    // 存檔：必須等後端回應才決定去留 —— 收到業務 422 時要留在本頁彈框。
    // 舊寫法「先呼叫、緊接著 $router.go(-1)」會讓使用者什麼都看不到就跳回列表。
    async saveInfo() {
      if (this.submitting) {
        return
      }
      this.submitting = true
      try {
        const saved = await this.submitWithRunNoFlow()
        if (saved) {
          this.$router.go(-1)
        }
      } finally {
        this.submitting = false
      }
    },
    checkChange() {
      if (this.adminStaff.setDefault === false) {
        const row = this.currentRow()
        if (row) {
          row.is_default = 0
        }
      }
    },
    // 用 id 找目前這一列（比 index 可靠：index 只在列表頁當下有效）
    currentRow() {
      const byId = this.selectList.find(
        (el) => String(el.id) === String(this.pageId)
      )
      if (byId) {
        return byId
      }
      return this.selectList[this.pageIndex]
    },
    getManageProperties() {
      this.optionsLoding = true
      getManageProperties(this.optionType)
        .then((res) => {
          this.selectList = []
          res.data.map((el) => {
            if (el.status !== '1') {
              this.selectList.push(el)
            }
          })
          const row = this.currentRow()
          if (!row) {
            this.$message.error('找不到要修訂的選項，請由列表重新進入。')
            this.optionsLoding = false
            return
          }
          // 編輯時輪次編號只讀展示，且「不」預填 adminStaff.runNo：
          // 只有在使用者真的確認要改時，才把 run_no 放進 payload。
          this.currentRunNo = row.run_no || ''
          this.derivedRunNo =
            row.derived_run_no === undefined ? null : row.derived_run_no
          this.adminStaff = {
            selection: row.name_en,
            name_cn: row.name_zh_hk,
            setDefault: row.is_default !== 0,
            remarks: row.remarks,
            runNo: ''
          }
          this.optionsLoding = false
        })
        .catch(() => {
          this.optionsLoding = false
        })
    },
    // 組出 payload（保留原本新增／編輯對 is_default 的不同處理）
    buildPayload() {
      let isDefault = false
      if (this.isTheatreDay) {
        isDefault = false
      } else if (this.isCreate) {
        const useDefault =
          this.adminStaff.setDefault !== false &&
          this.adminStaff.setDefault !== ''
        isDefault = useDefault ? 1 : 0
      } else {
        isDefault = this.adminStaff.setDefault === false ? 0 : 1
      }
      const data = {
        name_en: this.adminStaff.selection,
        name_zh_hk: this.adminStaff.name_cn,
        remarks: this.adminStaff.remarks,
        is_default: isDefault
      }
      if (this.isCreate) {
        data.type = this.optionType
      }
      if (this.isFilmVersion) {
        const runNo = String(this.adminStaff.runNo || '').trim()
        if (runNo) {
          data.run_no = runNo
        }
      }
      return data
    },
    // 送出 → 收到業務 422 就問使用者 → 帶 run_no 重送。
    // 最多 3 輪：一輪處理「派生不出 / 輪次編號變更 / 碼重複 / 碼無效」其中一種，
    // 使用者回答後重送；若又撞到另一種（例如改完碼才發現碼重複）再問一次。
    // （2026-09 後端已把重名檢查提到 mismatch 之前，所以「先問碼、才說重名」的連兩次 422 已不再出現。）
    async submitWithRunNoFlow() {
      const payload = this.buildPayload()
      for (let attempt = 0; attempt < 3; attempt += 1) {
        try {
          if (this.isCreate) {
            await creatManagePropertiesApi(payload)
          } else {
            await editManagePropertiesApi(this.pageId, payload)
          }
          return true
        } catch (error) {
          const body = error && error.response && error.response.data
          const retry = await this.resolveWriteError(body, payload)
          if (!retry) {
            return false
          }
        }
      }
      this.$message.error('重試次數過多，請確認資料後再試。')
      return false
    },
    // 回傳 true＝payload 已更新、可以重送
    async resolveWriteError(body, payload) {
      // 1) Laravel 欄位校驗 422：{ message, errors }
      if (body && body.errors && typeof body.errors === 'object') {
        const text = Object.values(body.errors)
          .flat()
          .filter(Boolean)
          .join('<br/>')
        this.$message({
          dangerouslyUseHTMLString: true,
          type: 'error',
          message: text || '提交的資料有誤，請檢查後再試。'
        })
        return false
      }
      // 2) 業務 422：{ result: 'fail', data: { reason, ... } }
      //    注意 data 的欄位隨 reason 變化（duplicate_name 沒有輪次編號欄位）
      if (!body || body.result !== 'fail' || !body.data) {
        if (body && body.message) {
          this.$message.error(body.message)
        }
        return false
      }
      const { reason } = body.data
      if (reason === 'duplicate_name') {
        this.$message.error(
          `選項名稱「${body.data.name_en ||
            payload.name_en}」已存在，請改用其他名稱。`
        )
        return false
      }
      if (reason === 'duplicate_run_no') {
        const dup = body.data.run_no
        // 這個碼是使用者自己填的嗎？（只有「新增 + 派生不出」時才會是）
        const userSupplied =
          payload.run_no !== undefined && payload.run_no !== ''
        // 只有「新增且使用者自填」時，請他換一個才有意義：
        //  - 新增時若名稱可派生，碼由名稱決定、使用者改不了 → 只能改名
        //  - 編輯時只接受「現值／派生值」二選一 → 自由輸入會被 invalid_run_no 擋掉
        if (this.isCreate && userSupplied) {
          const again = await this.askRunNo({
            title: '輪次編號重複',
            message: `輪次編號「${dup}」已被其他選項使用，請換一個（僅供系統判定，不會顯示給使用者）。`,
            initial: dup
          })
          if (again === null) {
            return false
          }
          payload.run_no = again
          return true
        }
        // 編輯時選了「用新值」、但新值已被佔用 → 退回沿用現值（此時唯一還有效的值）
        const canFallback =
          !this.isCreate &&
          this.currentRunNo &&
          String(payload.run_no) === String(this.derivedRunNo)
        if (canFallback) {
          try {
            await this.$confirm(
              `輪次編號「<b>${this.escapeHtml(
                dup
              )}</b>」已被其他選項使用，無法改成新值。<br/>要改為沿用現值「<b>${this.escapeHtml(
                this.currentRunNo
              )}</b>」嗎？`,
              '輪次編號重複',
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '沿用現值',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'warning'
              }
            )
            payload.run_no = this.currentRunNo
            return true
          } catch (action) {
            return false
          }
        }
        this.$message.error(
          `輪次編號「${dup}」已被其他選項使用，請改用其他名稱。`
        )
        return false
      }
      if (reason === 'invalid_run_no') {
        // 2026-09 後端新增：提交的 run_no 既不是「現值」也不是「派生值」。
        // 實測新增時也會檢查（name_en="20.0" 派生 20，填 run_no="99" → 422）。
        // 正常流程走不到這裡，最常見的是使用者在新增表單手填了其實可自動派生的碼。
        const current = body.data.current_run_no
        const derived = body.data.derived_run_no
        const hasDerived =
          derived !== null && derived !== undefined && derived !== ''
        if (hasDerived) {
          const currentLine = current ? `<br/>（此列現值為 <b>${this.escapeHtml(current)}</b>）` : ''
          try {
            await this.$confirm(
              `「${body.data.name_en}」會自動派生出輪次編號 <b>${this.escapeHtml(
                derived
              )}</b>，不需要手填。${currentLine}<br/>要改回「自動派生」嗎？`,
              '輪次編號不需要手填',
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '改回自動派生',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'warning'
              }
            )
            delete payload.run_no
            return true
          } catch (action) {
            return false
          }
        }
        this.$message.error('這個輪次編號不是有效的選擇，請重新整理後再試。')
        return false
      }
      if (reason === 'undeterminable') {
        // 派生不出輪次編號。
        // ⚠️ PUT 只能「現值 / 派生值」二選一，而這裡 derived 是 null ——
        //    所以**更新時唯一有效的值就是現值**：直接沿用即可，
        //    不需要（也不可能）讓使用者自由輸入。
        const current = body.data.current_run_no
        if (!this.isCreate) {
          if (current) {
            payload.run_no = current
            return true
          }
          // 沒有現值可沿用（名稱改了、又派生不出）：只能改名
          this.$message.error(
            '此名稱無法產生輪次編號，且這一列沒有可沿用的現值，請改用其他名稱。'
          )
          return false
        }
        // 新增時沒有現值可沿用 → 必須請使用者給一個（後端允許自訂，含中文）
        const nameEn = body.data.name_en
        const value = await this.askRunNo({
          title: '需要「輪次編號」',
          message: `無法從「${nameEn}」自動產生輪次編號，請自行輸入（可沿用中文名）。`,
          initial: nameEn || ''
        })
        if (value === null) {
          return false
        }
        payload.run_no = value
        return true
      }
      if (reason === 'mismatch') {
        // 改名導致輪次編號改變：後端只接受「現值 / 派生值」二選一
        // （P3 起會驗證：兩者皆非 → 422 invalid_run_no），所以這裡不提供自由輸入。
        const current = body.data.current_run_no
        const derived = body.data.derived_run_no
        try {
          await this.$confirm(
            `此變更會把「輪次編號」從 <b>${this.escapeHtml(
              current
            )}</b> 改為 <b>${this.escapeHtml(derived)}</b>。<br/>` +
              '若只想改顯示名稱、不想動輪次編號，請按「沿用現值」。',
            '輪次編號將被改變',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '用新值',
              cancelButtonText: '沿用現值',
              distinguishCancelAndClose: true,
              type: 'warning'
            }
          )
          payload.run_no = derived
          return true
        } catch (action) {
          if (action === 'cancel') {
            payload.run_no = current
            return true
          }
          return false
        }
      }
      let fallback = '存檔失敗，請稍後再試。'
      if (body.error && body.error.message) {
        fallback = body.error.message
      }
      this.$message.error(fallback)
      return false
    },
    // 彈「輪次編號」輸入框；取消／關閉回傳 null
    askRunNo({ title, message, initial }) {
      return new Promise((resolve) => {
        this.$prompt(
          message || '請輸入輪次編號（僅供系統判定，不會顯示給使用者）',
          title,
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            inputValue: initial,
            closeOnClickModal: false,
            inputValidator: (value) => {
              const raw = value === null || value === undefined ? '' : value
              const v = String(raw).trim()
              if (!v) {
                return '輪次編號不可為空'
              }
              if (v.length > 50) {
                return '輪次編號不可超過 50 個字元'
              }
              return true
            }
          }
        )
          .then(({ value }) => resolve(String(value).trim()))
          .catch(() => resolve(null))
      })
    },
    escapeHtml(value) {
      if (value === null || value === undefined) {
        return ''
      }
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    }
    // 註：2026-09 後端已在字典列表回傳 derived_run_no，前端不再自行實作派生規則。
    // 舊的 deriveRunNo()（複製後端 Str::slug 的近似版）已移除：
    // Str::slug 具字元轉寫能力（Café → cafe、Москва → moskva），前端複製必然漂移。
  },
  created() {
    this.pageId = this.$route.query.id
    this.optionType = this.$route.query.type
    this.pageIndex = this.$route.query.index
    this.pagePath = this.$route.path
    if (this.pagePath === '/dashboard/edit-admin-properties-options') {
      this.getManageProperties()
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-title {
  width: 100%;
  color: #0e72bc;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
.sub-bg {
  background: #f1feff;
}
.edit-select {
  text-align: right;
}
.line {
  height: 1.5px;
  background: #0e72bc;
  width: 100%;
  margin: 20px 0;
}
</style>
